import {Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import * as Sentry from '@sentry/angular';

@Injectable()
export class GlobalErrorHandler extends Sentry.SentryErrorHandler {

  constructor() {
    super({logErrors: true});
  }

  /**
   * Manejar el error
   *
   */
  override handleError(error: any) {
    Sentry.withScope((scope) => {
      scope.setTag('errorType', this.getErrorType(error));

      if (error instanceof HttpErrorResponse) {
        scope.setTag('httpStatus', error.status.toString());
      }

      super.handleError(error);
    });
  }

  /**
   * Obtener el tipo de error
   *
   */
  private getErrorType(error: any): string {

    if (error instanceof HttpErrorResponse) {
      return 'HTTP';
    }

    if (error instanceof TypeError) {
      return 'TypeError';
    }

    if (error instanceof ReferenceError) {
      return 'ReferenceError';
    }

    if (error instanceof RangeError) {
      return 'RangeError';
    }

    return 'Generic';
  }
}
